import { createTypesenseSearch } from '~/lib/search/typesense'
import type { TypesenseSearchConfig } from '~/lib/search/typesense'

/**
 * Typesense search client, shared per process. useRuntimeConfig() is called lazily on first use,
 * so it always runs within a valid Nuxt context. The Typesense SDK itself loads on the first search.
 */

let _typesenseSearch: ReturnType<typeof createTypesenseSearch> | null = null

/** Algolia-compatible Typesense client: `initIndex(name).search(query, requestOptions)` */
export function useTypesenseSearch() {
  if (!_typesenseSearch) _typesenseSearch = createTypesenseSearch(useRuntimeConfig().public.search.typesense as unknown as TypesenseSearchConfig)
  return _typesenseSearch
}
